export const hotspots = [
  {
    id: 'unloading_anno',
    label: 'Unloading',
    description: 'The Unloading area manages the safe and efficient offloading of goods from transport vehicles onto the warehouse floor, marking the first physical step in the inbound supply chain process.',
    groups: ['LODEM', 'CSS', 'MAG', 'TRG', 'SLAM', 'ProGMA']
  },
  {
    id: 'inbound_anno',
    label: 'Inbound',
    description: 'Inbound operations focus on receiving goods from suppliers and preparing them for storage within the warehouse. This includes unloading, inspection, sorting, and system entry of incoming products.',
    groups: ['LODEM', 'CSS', 'SLAM', 'MAG', 'AEC', 'LIFT', 'EASE', 'ProGMA', 'TRG', 'ACE', 'Solutions Community']
  },
  {
    id: 'item_storage_anno',
    label: 'Item Storage',
    description: 'The Automated Storage and Retrieval System (ASRS) is a highly advanced solution that uses robotics and computer-controlled systems to store and retrieve goods with precision and speed.',
    groups: ['ASRS', 'TRG', 'ACE', 'CSS', 'SLAM', 'EASE', 'Solutions Community']
  },
  {
    id: 'item_sort_anno',
    label: 'Item Sort',
    description: 'The Item Sort area uses automated sortation technology to classify and route individual items to the correct downstream processes, maximizing throughput and reducing manual handling errors.',
    groups: ['ASRS', 'CSS', 'TRG', 'ACE', 'ProGMA', 'Solutions Community']
  },
  {
    id: 'merge_anno',
    label: 'Merge',
    description: 'The Merge area is responsible for consolidating multiple product flows into a single streamlined output. It ensures synchronization, reduces delays, and improves operational efficiency.',
    groups: ['CSS', 'ACE', 'SLAM', 'SMA', 'ProGMA', 'Solutions Community']
  },
  {
    id: 'bulk_storage_anno',
    label: 'Bulk Storage',
    description: 'Bulk Storage is designed to handle large volumes of goods efficiently by organizing them into structured rack systems. This area plays a critical role in maintaining inventory stability, ensuring that products are stored safely while maximizing space utilization.',
    groups: ['RMI', 'SMA', 'ProGMA', 'AEC', 'TRG']
  },
  {
    id: 'tote_storage_anno',
    label: 'Case/Tote Storage',
    description: 'The Case/Tote Storage system automates high-speed transport and storage of totes and cases across multiple storage levels, minimizing manual handling and reducing travel time in dense storage environments.',
    groups: ['ASRS', 'TRG', 'ProGMA', 'ACE', 'Solutions Community']
  },
  {
    id: 'pallet_storage_anno',
    label: 'Pallet Storage',
    description: 'The Pallet Storage system provides automated deep-lane pallet storage and retrieval, maximizing floor space utilization and enabling efficient LIFO or FIFO inventory management.',
    groups: ['ASRS', 'RMI', 'TRG', 'ProGMA', 'ACE', 'CSS', 'Solutions Community']
  },
  {
    id: 'picking_auto_anno',
    label: 'Auto Pick',
    description: 'Auto Pick refers to automated picking systems that use robotics and intelligent software to select items from storage without human intervention, designed for high-speed operations.',
    groups: ['MAG', 'ASRS', 'TRG', 'CSS', 'SMA', 'ACE', 'EASE', 'ProGMA', 'Solutions Community']
  },
  {
    id: 'picking_manual_anno',
    label: 'Manual Pick',
    description: 'Manual Picking involves warehouse personnel physically selecting items from storage locations based on order requirements, providing flexibility for complex or low-volume orders.',
    groups: ['SMA', 'CSS', 'VRC', 'EASE', 'ProGMA', 'Solutions Community']
  },
  {
    id: 'control_anno',
    label: 'Control/Software Center',
    description: 'The Control and Software Center serves as the nerve center of the warehouse, housing the systems and teams responsible for managing warehouse execution, automation controls, and real-time operational visibility.',
    groups: ['Solutions Community', 'WERC', 'TRG', 'MAG', 'ACE']
  },
  {
    id: 'sorting_anno',
    label: 'Sorting',
    description: 'The Sorting area uses advanced sortation systems to direct products to their correct destinations within the warehouse, ensuring accurate and efficient order fulfillment flows.',
    groups: ['CSS', 'Solutions Community', 'ProGMA', 'SMA', 'TRG', 'EASE', 'ACE']
  },
  {
    id: 'packing_anno',
    label: 'Packing',
    description: 'The Packing area is where items are securely packed before shipment to ensure they reach customers in perfect condition. This stage involves selecting appropriate packaging materials and verifying order accuracy.',
    groups: ['SLAM', 'CSS', 'SMA', 'ACE', 'ProGMA', 'EASE', 'Solutions Community']
  },
  {
    id: 'slam_anno',
    label: 'SLAM',
    description: 'The SLAM (Scan, Label, Apply, Manifest) area handles the final processing of packages — applying labels, scanning barcodes, and generating manifests to ensure accurate and compliant shipment.',
    groups: ['SLAM', 'CSS', 'ACE']
  },
  {
    id: 'outbound_anno',
    label: 'Outbound',
    description: 'Outbound operations manage the final stage of warehouse activities, where goods are prepared and dispatched to customers or distribution centers, including order consolidation, packaging, and shipping.',
    groups: ['SLAM', 'LODEM', 'LIFT', 'EASE', 'AEC', 'TRG', 'MAG', 'CSS', 'ACE', 'ProGMA', 'Solutions Community']
  },
  {
    id: 'loading_anno',
    label: 'Loading',
    description: 'The Loading area is the final physical handoff point where packed and manifested shipments are loaded onto outbound vehicles for last-mile delivery or distribution center transfer.',
    groups: ['LODEM', 'CSS', 'MAG', 'TRG', 'SLAM', 'ProGMA']
  }
];
